import { BQuery } from '@bytel/query';
import getConfig from '@misc/configuration';
import * as React from 'react';
import { useContext } from 'react';
import { useIdToken } from './auth-provider';

export type BQueryConfig = {
  baseURL: string;
  authToken: string;
  cacheMaxAge?: number;
};

const BytelBQueryContext = React.createContext<BQuery | null>(null);

/**
 * Provider pour l'instance BQuery dédiée aux APIs Bytel
 * Utilise idToken pour l'authentification et BYTEL_API_URL
 */
export const BytelBQueryProvider: React.FC = ({ children }) => {
  // On ne passe pas le logger a BQuery car Prisme n'est pas disponible
  // const logger = useLogger();
  const logger = undefined;
  const idToken = useIdToken();

  const bytelBQuery = React.useMemo(() => {
    return new BQuery(
      getConfig().then((config) => ({
        baseURL: config.BYTEL_API_URL ?? 'http://localhost:7001',
        cache: {
          maxAge: 5 * 60 * 1000,
          exclude: {
            paths: [],
          },
        },
        authProvider: () => idToken,
      })),
      logger,
    );
  }, [logger, idToken]);

  return <BytelBQueryContext.Provider value={bytelBQuery}>{children}</BytelBQueryContext.Provider>;
};

/**
 * Hook pour récupérer l'instance BQuery Bytel depuis le Provider
 */
export const useBytelBQuery = (): BQuery => {
  const context = useContext(BytelBQueryContext);
  if (context === undefined || context === null) {
    throw new Error('The `useBytelBQuery` hook must be used within a BytelBQueryProvider');
  }
  return context;
};
